/** Мост workspace УДГСПЗ → MapLibre heatmap layer (Wave 5.4). */

export const UDGSPZ_HEATMAP_EVENT = "udgspzHeatmapOverlay";

export type UdgspzHeatmapOverlayDetail = {
  featureCollection: GeoJSON.FeatureCollection | null;
};

export function dispatchUdgspzHeatmapOverlay(
  featureCollection: GeoJSON.FeatureCollection | null,
): void {
  window.dispatchEvent(
    new CustomEvent<UdgspzHeatmapOverlayDetail>(UDGSPZ_HEATMAP_EVENT, {
      detail: { featureCollection },
    }),
  );
}
